import { DATA_TABLE_PAGE_SIZE_KEY } from '../models/data-table-settings';

/**
 * Save the pageSize to local storage
 * @param pageSize
 */
export const saveSelectedPageSize = (pageSize: number) => {
  localStorage.setItem(DATA_TABLE_PAGE_SIZE_KEY, String(pageSize));
};
